module.exports = __webpack_public_path__ + "img/chain_iris_w.fad49603.png";